import { memo } from 'react'
import { useDispatch } from '@tabeeb/store'
import { shareContent } from '@tabeeb/modules/contentSharings/actions'
import { Button, DialogActions } from '@collaborate-health/uikit'
import { SharingDialogStage } from '@tabeeb/modules/contentSharings/types'

interface ActionsProps {
  stages: SharingDialogStage[]
  currentStageIndex: number
  setCurrentStageIndex: (index: number) => void
  onClose: () => void
}

const Actions: React.FC<ActionsProps> = ({ stages, setCurrentStageIndex, currentStageIndex, onClose }) => {
  const dispatch = useDispatch()
  const currentStage = stages[currentStageIndex]
  if (!currentStage) {
    return null
  }

  const isStageOptional = currentStage.steps.every((step) => step.isOptional)
  const isStageCompleted = isStageOptional || currentStage.steps.every((step) => step.isOptional || step.isCompleted)
  const continueBtnText = isStageOptional ? 'Skip' : 'Continue'

  const _handleContinueClick = () => {
    if (!isStageCompleted) {
      return
    }

    const isLastStage = stages.length === 1 || currentStageIndex === stages.length - 1
    if (isLastStage) {
      dispatch(shareContent())
      onClose()
    } else {
      setCurrentStageIndex(currentStageIndex + 1)
    }
  }

  return (
    <DialogActions>
      <Button onClick={onClose} color='primary'>
        Cancel
      </Button>
      <Button onClick={_handleContinueClick} color='primary' variant='contained' disabled={!isStageCompleted}>
        {continueBtnText}
      </Button>
    </DialogActions>
  )
}

export default memo(Actions)

